import overridable from '../utils/overridable'

const ThemeOverrides = () => <></>

export default overridable('ThemeOverrides')(ThemeOverrides)
